export const CALENDAR_COLORS = [
    {
        id: 'color-1',
        background: '#dbeafe',
        text: '#1e40af',
        border: '#3b82f6',
    },
    {
        id: 'color-2',
        background: '#fee2e2',
        text: '#991b1b',
        border: '#ef4444',
    },
    {
        id: 'color-3',
        background: '#dcfce7',
        text: '#166534',
        border: '#22c55e',
    },
    {
        id: 'color-4',
        background: '#fef3c7',
        text: '#92400e',
        border: '#f59e0b',
    },
    {
        id: 'color-5',
        background: '#e9d5ff',
        text: '#6b21a8',
        border: '#a855f7',
    },
    {
        id: 'color-6',
        background: '#fed7aa',
        text: '#9a3412',
        border: '#ea580c',
    },
    {
        id: 'color-7',
        background: '#cffafe',
        text: '#0e7490',
        border: '#06b6d4',
    },
    {
        id: 'color-8',
        background: '#f3f4f6',
        text: '#374151',
        border: '#6b7280',
    },
];

export function getNextAvailableColor(eventsForDay, existingColors = null) {
    const usedColors =
        existingColors ||
        eventsForDay
            .map((event) => event.color)
            .filter((color) => color && color.startsWith('color-'));

    for (const color of CALENDAR_COLORS) {
        if (!usedColors.includes(color.id)) {
            return color;
        }
    }

    return CALENDAR_COLORS[0];
}

export function getColorById(colorId) {
    return CALENDAR_COLORS.find((color) => color.id === colorId) || null;
}

export function getAllColors() {
    return CALENDAR_COLORS;
}
